import config from '../config.js';
import { authFetch } from '../utils/apiClient.js';

const WORKFLOW_TYPES = ['INDEX', 'SEARCH', 'DOCUMENT_INDEX', 'DOCUMENT_PROCESS', 'DOCUMENT_SEARCH', 'DOCUMENT_CATEGORISE'];

async function getWorkflow(clientId, workflowType) {
  const res = await authFetch(`${config.backendUrl}/v1/workflows/${clientId}/${workflowType}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Failed to load workflow (${res.status})`);
  return res.json();
}

async function createWorkflow(payload) {
  const res = await authFetch(`${config.backendUrl}/v1/workflows`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Failed to create workflow (${res.status})`);
  return res.json();
}

async function updateWorkflow(payload) {
  const res = await authFetch(`${config.backendUrl}/v1/workflows`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Failed to update workflow (${res.status})`);
  return res.json();
}

export const workflowApi = { getWorkflow, createWorkflow, updateWorkflow, WORKFLOW_TYPES };
